import React from "react";
import { Dropdown, Navbar } from "flowbite-react";
import { Link } from "react-router-dom";

export default function NavbarHome() {
  return (
    <div className="fixed w-full custom-z-index">
      <Navbar fluid={true} className="py-5 shadow-lg">
        <Navbar.Brand>
          <img
            src={require("../images/logo.jpg")}
            className="rounded h-6 mr-3 ml-20 sm:h-10"
            alt="Flowbite Logo"
          />
          <span className="self-center text-xl font-bold whitespace-nowrap text-green-700 dark:text-white">
            Green Care Blitz
          </span>
        </Navbar.Brand>
        <Navbar.Toggle className="mr-10" />
        <Navbar.Collapse>
          <Link to={"/"}>
            <Navbar
              to={"/"}
              className="font-bold custom-font-color-navbar-home"
            >
              Home
            </Navbar>
          </Link>
          <Navbar className="custom-font-color-navbar">
            <Dropdown label="Pages" inline={true}>
              <Link to={"/page-about"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  About
                </Dropdown.Item>
              </Link>
              <Link to={"/page-shop"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Shop
                </Dropdown.Item>
              </Link>
              <Link to={"/page-event"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Event
                </Dropdown.Item>
              </Link>
            </Dropdown>
          </Navbar>
          <Navbar className="custom-font-color-navbar">
            <Dropdown label="Features" inline={true}>
              <Link to={"/feature-header-satu"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Header 1
                </Dropdown.Item>
              </Link>
              <Link to={"/feature-header-dua"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Header 2
                </Dropdown.Item>
              </Link>
              <Link to={"/feature-header-tiga"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Header 3
                </Dropdown.Item>
              </Link>
            </Dropdown>
          </Navbar>
          <Navbar className="custom-font-color-navbar">
            <Dropdown label="Galery" inline={true}>
              <Link to={"/galery-regular"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Regular
                </Dropdown.Item>
              </Link>
              <Link to={"/galery-corousel"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Corousel
                </Dropdown.Item>
              </Link>
              <Link to={"/galery-full"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Full Width
                </Dropdown.Item>
              </Link>
            </Dropdown>
          </Navbar>
          <Navbar className="custom-font-color-navbar">
            <Dropdown label="Contact" inline={true}>
              <Link to={"/contact-satu"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Contact 1
                </Dropdown.Item>
              </Link>
              <Link to={"/contact-dua"}>
                <Dropdown.Item className="custom-font-color-navbar">
                  Contact 2
                </Dropdown.Item>
              </Link>
            </Dropdown>
          </Navbar>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}
